import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "logic px-0.5" }

import { computed } from "vue";
import { assertUnreachable } from "@/utils";
import {
  isCondNot,
  isCondAnd,
  isCondOr,
  ConditionLogic,
  ConditionTypeLogic,
  conditionTypeLogic,
} from "@/keyboard/leds";
import * as cutils from "@/keyboard/condition_utils";
import ConditionView from "@/components/leds/ConditionView.vue";
import InParens from "@/components/leds/InParens.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionViewLogic',
  props: {
    condition: {},
    parentLogic: {}
  },
  setup(__props: any) {

const props = __props;

const cond = computed(() => props.condition);
const inner = computed(() => cutils.inner(cond.value));
const condType = computed(() => conditionTypeLogic(cond.value));
const outerParens = computed(() =>
  cutils.outerParens(condType.value, props.parentLogic)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InParens, {
    visible: outerParens.value,
    baseClass: "cond-view-paren",
    hoverClass: "cond-view-paren cond-view-paren-hover"
  }, {
    default: _withCtx(() => [
      (_unref(isCondNot)(_ctx.condition))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "logic pr-0.5" }, "not", -1)),
            _createVNode(ConditionView, {
              condition: _ctx.condition.Not,
              parentLogic: condType.value
            }, null, 8, ["condition", "parentLogic"])
          ], 64))
        : (_unref(isCondAnd)(_ctx.condition) || _unref(isCondOr)(_ctx.condition))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (inner.value.length > 0)
                ? (_openBlock(), _createBlock(ConditionView, {
                    key: 0,
                    condition: inner.value[0],
                    parentLogic: condType.value
                  }, null, 8, ["condition", "parentLogic"]))
                : _createCommentVNode("", true),
              (inner.value.length > 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(isCondAnd)(_ctx.condition) ? "and" : "or"), 1),
                    (inner.value.length > 1)
                      ? (_openBlock(), _createBlock(ConditionView, {
                          key: 0,
                          condition: cutils.wrap(_ctx.condition, inner.value.slice(1)),
                          parentLogic: condType.value
                        }, null, 8, ["condition", "parentLogic"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(_unref(assertUnreachable)(_ctx.condition)), 1)
            ], 64))
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})